module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('hrms-search-box-table', {
    attrs: {
      "receivedStore": _vm.receivedHrms6aeDetailSearch,
      "searchBoxAlias": "hrms6ae-detail",
      "columns": _vm.columnsDetail,
      "data": _vm.detail.table,
      "maxRowspan": _vm.maxRowspanDetail,
      "addInlineEventBool": false,
      "editInlineEventBool": _vm.saveButtonDisp,
      "deleteInlineEventBool": false,
      "backEvent": _vm.backEvent,
      "saveInlineBtnDisp": _vm.saveButtonDisp,
      "saveInlineEvent": _vm.callSave,
      "columnEvent": _vm.columnEvent,
      "nowLang": _vm.nowLang,
      "rowDisableCondition": _vm.rowDisableCondition
    },
    model: {
      value: (_vm.paramSearchDetail),
      callback: function($$v) {
        _vm.paramSearchDetail = $$v
      },
      expression: "paramSearchDetail"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "box-footer"
  }, [_c('button', {
    staticClass: "btn bg-color-skin pull-right",
    attrs: {
      "type": "button",
      "data-toggle": "modal",
      "data-target": "#hrms6ae-popup"
    }
  }, [_c('i', {
    staticClass: "fa fa-list-alt"
  }), _vm._v(" " + _vm._s(_vm.labels['HRMS6AEC2']['200']))])]), _vm._v(" "), _c('popup', {
    attrs: {
      "labels": _vm.labels,
      "detailPopup": _vm.detail.popup,
      "columnsDetailPopup": _vm.columnsDetailPopup,
      "maxRowspanPopup": _vm.maxRowspanPopup
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-0e2b0b4d!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/hrms6ae/detail.vue
// module id = 3556
// module chunks = 1